import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./brand/tokens.css";
import "./brand/gate.css";
import "./brand/shell.css";
// The contained component-library layer (foundation pilot): layered, no global preflight.
import "./brand/ui.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Root container #root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
